import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ActionCreators as UndoActionCreators } from 'redux-undo';

const specialCharacters: Record<string, string> = {
    CTRL: 'ctrl',
    ALT: 'alt',
    SHIFT: 'shift',
};

const keyState: Record<string, boolean> = {
    y: false,
    z: false,
};

const checkCombinations = (keyEvent: KeyboardEvent, keys: string[]) => {
    let isValid = false;
    for (let i = 0; i < keys.length; i++) {
        const curKey = keys[i];
        if (keyState[curKey] === false) {
            isValid = false;
            break;
        }

        if (specialCharacters[curKey]) {
            if (keyEvent[`${curKey}Key` as 'ctrlKey' | 'altKey' | 'shiftKey'] === false) {
                isValid = false;
                break;
            }
        }
        isValid = true;
    }
    return isValid;
};

interface Props {
    onUndo: () => void;
    onRedo: () => void;
}

function Shortcuts(props: Props) {
    const config = [
        { fn: props.onUndo, keys: [specialCharacters.CTRL, 'z'] },
        { fn: props.onRedo, keys: [specialCharacters.CTRL, 'y'] },
    ];

    const onKeyDown = (keyDownEvent: KeyboardEvent) => {
        // keyDownEvent.preventDefault();

        keyState[keyDownEvent.key] = true;

        const filtered = config.filter((shortcut) => shortcut.keys.includes(keyDownEvent.key));
        filtered.forEach((shortcut) => {
            if (checkCombinations(keyDownEvent, shortcut.keys)) {
                shortcut.fn();
            }
        });
    };

    const onKeyUp = (keyUpEvent: KeyboardEvent) => {
        // Prevent default key actions, if desired
        keyUpEvent.preventDefault();

        // Track down key release
        keyState[keyUpEvent.key] = false;
    };

    useEffect(() => {
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('keyup', onKeyUp);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('keyup', onKeyUp);
        };
    }, []);
    return <></>;
}

const mapStateToProps = () => ({});
const ShortcutsContainer = connect(mapStateToProps, (dispatch) => ({
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo()),
}))(Shortcuts);

export default ShortcutsContainer;
